import { Directive, HostBinding, Input, OnChanges, OnInit } from '@angular/core';
import { CustomBreakpoint } from '../../../../helpers/breakpoint.helper';
import { BlogPost } from '../../../../models/blog-posts.model';

@Directive({ selector: '[blogTileImage]' })
export class TileImageDirective implements OnInit, OnChanges {
    @Input() public post?: BlogPost;
    @Input() public breakpoint?: CustomBreakpoint;
    @Input() public size?: string;

    @HostBinding('attr.src') public source?: string;
    @HostBinding('attr.alt') public alt?: string;
    @HostBinding('attr.title') public title?: string;

    public ngOnInit(): void {
        if (!this.post) {
            return;
        }

        this.alt = this.post.hero_picture_alt;
        this.title = this.post.hero_picture_title;
        this.updatePictureSize(this.post);
    }

    public ngOnChanges(): void {
        if (this.post && this.breakpoint && this.breakpoint >= 0) {
            this.updatePictureSize(this.post);
        }
    }

    private updatePictureSize(post: BlogPost): void {
        /* if (this.post.hero_picture_res) {
            // check if not svg
            if (!this.post.hero_picture_res.img) {
                switch (this.breakpoint) {
                    case 0: {
                        const sources = this.post.hero_picture_res.bp0.all
                            .split(',')
                            .map((u: string) => u.trim());
                        this.source = sources[Number(isRetinaDisplay())];
                        break;
                    }
                    case 1: {
                        const sources = this.post.hero_picture_res.bp1.all
                            .split(',')
                            .map((u: string) => u.trim());
                        this.source = sources[Number(isRetinaDisplay())];
                        break;
                    }
                    case 2: {
                        const resolutions = this.post.hero_picture_res.bp2;
                        let sources;
                        switch (this.size) {
                            case 'm':
                                sources = resolutions.m.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            case 'l':
                                sources = resolutions.l.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    case 3: {
                        const resolutions = this.post.hero_picture_res.bp3;
                        let sources;
                        switch (this.size) {
                            case 'm':
                                sources = resolutions.m.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            case 'l':
                                sources = resolutions.l.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    case 4: {
                        const resolutions = this.post.hero_picture_res.bp4;
                        let sources;
                        switch (this.size) {
                            case 's':
                                sources = resolutions.s.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            case 'm':
                                sources = resolutions.m.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            case 'l':
                                sources = resolutions.l.split(',').map((u: string) => u.trim());
                                this.source = sources[Number(isRetinaDisplay())];
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    default:
                        break;
                }
            } else {
                // svg
                this.source = this.post.hero_picture_res.img;
            }
        } */

        this.source = post.hero_picture.mq3;
    }
}
